module.exports = __webpack_public_path__ + "static/media/ST 3 Einkltaschen mit Kickers.66128705.jpg";